import React from 'react';
import Icon from '../../../components/AppIcon';

const DealStats = ({ stats }) => {
  const statItems = [
    {
      id: 'active',
      label: 'Active Deals',
      value: stats?.activeDeals,
      icon: 'Tag',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'ending',
      label: 'Ending Soon',
      value: stats?.endingSoon,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      id: 'exclusive',
      label: 'Exclusive Deals',
      value: stats?.exclusiveDeals,
      icon: 'Star',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'savings',
      label: 'Total Savings',
      value: `$${stats?.totalSavings?.toLocaleString()}`,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {statItems?.map((item) => (
        <div key={item?.id} className="bg-card border border-border rounded-xl p-6 hover:shadow-subtle transition-shadow">
          <div className="flex items-center space-x-3">
            <div className={`p-3 rounded-lg ${item?.bgColor}`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
            <div>
              <div className="text-2xl font-bold text-text-primary">
                {item?.value}
              </div>
              <div className="text-sm text-muted-foreground">
                {item?.label}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DealStats;